import { mergeStyles, mergeStyleSets } from '@uifabric/merge-styles'
import classnames from 'classnames'
import React from 'react'
import { SpanningBar } from './spanning_bar'

const bold_text = (size: number) => {
	return mergeStyles({
		fontWeight: 'bold',
		fontSize: size
	})
}

export const Header = () => (
	<SpanningBar>
		<div className={bold_text(24)}>Hyperkey</div>
	</SpanningBar>
)